import BulletTypography from '@/common/components/base/typography/BulletTypography.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { Flex } from 'styled-system/jsx';
import TelephoneIcon from '@/common/assets/icons/phoneIcon.svg?react';
import CustomIcon from '@/common/components/base/customIcon/CustomIcon.tsx';
import { token } from 'styled-system/tokens';
import { ParticipantCardItemType } from '@/modules/adjusterReportModules/IncidentParticipants/components/participantCardItem/participantCardItem.type';

export default ({ name, telephone }: ParticipantCardItemType) => {
  return (
    <Flex flexDirection={'column'} gap="10px" mt="10px">
      <Flex justifyContent="space-between">
        <BulletTypography
          backgroundColor={'black-3'}
          textStyle="b2"
          color="black-3"
          flexShrink={0}
        >
          نام
        </BulletTypography>

        <Typography textAlign="left" mr="7px" textStyle="b2" color="black-1">
          {name}
        </Typography>
      </Flex>
      {telephone && (
        <Flex justifyContent="space-between">
          <BulletTypography
            backgroundColor={'black-3'}
            textStyle="b2"
            color="black-3"
            flexShrink={0}
          >
            تلفن همراه
          </BulletTypography>

          <Flex alignItems="center">
            <a href={`tel:${telephone}`}>
              <CustomIcon backgroundColor="green-4" width={26} height={26}>
                <TelephoneIcon stroke={token('colors.green')} />
              </CustomIcon>
            </a>
            <Typography
              textAlign="left"
              mr="7px"
              textStyle="b2"
              color="black-1"
            >
              {telephone}
            </Typography>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
